// Logo, ChartLine e MCCone. Sairam do App.js em 03/11/2026, inteiros
// e sem uma linha alterada. Nao leem nada do App: recebem tudo por
// props e so dependem do recharts.
import { LineChart, Line, AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts"

export const Logo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 470 110" height="52" style={{marginBottom:4, maxWidth:"100%"}}>
    <g stroke="#F2EFE9" strokeWidth="6.5" fill="none" strokeLinecap="round" strokeLinejoin="round" transform="translate(6,5)">
      <path d="M72 24 A34 34 0 1 0 72 76"/>
      <path d="M72 76 Q58 66 62 50"/>
    </g>
    <text x="126" y="72" fontFamily="Georgia,serif" fontSize="46" fontWeight="900" letterSpacing="-2" fill="#F2EFE9">CLAW<tspan fill="#8b93a1" fontSize="34" letterSpacing="4"> ETF</tspan></text>
    <text x="372" y="72" fontFamily="Georgia,serif" fontSize="18" fontStyle="italic" fill="#E9573F">krupt&#xF3;s</text>
  </svg>
)

export function ChartLine({ data, color, formatter }) {
  const id = "grad_" + Math.random().toString(36).slice(2)
  return (
    <ResponsiveContainer width="100%" height={200}>
    <AreaChart data={data} margin={{top:4, right:6, left:0, bottom:0}}>
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="0" y2="1">
          <stop offset="5%" stopColor={color} stopOpacity={0.12}/>
          <stop offset="80%" stopColor={color} stopOpacity={0.04}/>
          <stop offset="100%" stopColor={color} stopOpacity={0}/>
        </linearGradient>
      </defs>
      <XAxis dataKey="t" stroke="#333" fontSize={9} interval="preserveStartEnd" tick={{fill:"#6b7280"}} axisLine={false} tickLine={false} padding={{left:4, right:6}}/>
      <YAxis yAxisId="l" stroke="#333" fontSize={9} domain={["auto","auto"]} tick={{fill:"#6b7280"}} axisLine={false} tickLine={false} width={55}/>
      {data.some(d => d.ret !== undefined) && <YAxis yAxisId="r" orientation="right" stroke="#333" fontSize={9} tick={{fill:"#f59e0b"}} axisLine={false} tickLine={false} tickFormatter={(v) => v.toFixed(Math.max(...data.filter(d=>d.ret!==undefined).map(d=>Math.abs(d.ret)),0) < 10 ? 1 : 0)+"%"}/>}
      <Tooltip contentStyle={{backgroundColor:"#0a0a0f", border:"1px solid #1f2937", borderRadius:8, color:"#fff", fontSize:11}} formatter={formatter || ((v) => [v.toFixed(2)])}/>
      <Area yAxisId="l" type="monotone" dataKey="v" stroke={color} strokeWidth={1.5} fill={"url(#"+id+")"} dot={false}/>
      {data.some(d => d.ret !== undefined) && <Line yAxisId="r" type="monotone" dataKey="ret" name="retorno" stroke="#f59e0b" strokeWidth={1.2} strokeDasharray="3 3" dot={false}/>}
    </AreaChart>
    </ResponsiveContainer>
  )
}

export function MCCone({ mc, valor, refMc, refValor }) {
  if (!mc || !valor) return null
  const num = (x) => parseFloat(x) || 0
  // a mediana desloca linearmente no tempo; a dispersao abre por raiz de t,
  // que e como um passeio aleatorio espalha — abrir linear exagera o curto prazo
  const pts = []
  for (let m = 0; m <= 12; m++) {
    const f = m / 12, r = Math.sqrt(f)
    const med = num(mc.median), pes = num(mc.p10), oti = num(mc.p90)
    const o = { m: m === 0 ? "hoje" : m + "m" }
    o.med = Math.round(valor * (1 + (med / 100) * f))
    o.pes = Math.round(valor * (1 + (med / 100) * f + ((pes - med) / 100) * r))
    o.oti = Math.round(valor * (1 + (med / 100) * f + ((oti - med) / 100) * r))
    if (refMc && refValor) {
      const rm = num(refMc.median), rp = num(refMc.p10), ro = num(refMc.p90)
      o.rpes = Math.round(refValor * (1 + (rm / 100) * f + ((rp - rm) / 100) * r))
      o.roti = Math.round(refValor * (1 + (rm / 100) * f + ((ro - rm) / 100) * r))
    }
    pts.push(o)
  }
  return (
    <div style={{marginTop:10}}>
      <p style={{color:"#9ca3af", fontSize:10, margin:"0 0 2px 0"}}>Quanto a carteira pode valer em 12 meses</p>
      <p style={{color:"#6b7280", fontSize:10, margin:"0 0 4px 0"}}>Hoje ela vale <b style={{color:"#e2e8f0"}}>${valor.toFixed(2)}</b>.{(refValor && refMc) ? " Na foto valia $" + refValor.toFixed(2) + "." : ""}</p>
      <p style={{color:"#4b5563", fontSize:9, margin:"0 0 6px 0", lineHeight:1.5}}>
        Três valores para daqui a 12 meses, simulados com a volatilidade do último ano e sem nenhuma expectativa de direção: pessimista, mediana e otimista. As linhas coloridas são a carteira de hoje.{refMc ? " As cinzas, a da foto." : ""}
      </p>
      <ResponsiveContainer width="100%" height={170}>
        <LineChart data={pts} margin={{top:4, right:6, left:0, bottom:0}}>
          <XAxis dataKey="m" stroke="#333" fontSize={9} tick={{fill:"#6b7280"}} axisLine={false} tickLine={false}/>
          <YAxis stroke="#333" fontSize={9} domain={["auto","auto"]} tick={{fill:"#6b7280"}} axisLine={false} tickLine={false}/>
          <Tooltip contentStyle={{backgroundColor:"#0a0a0f", border:"1px solid #1f2937", borderRadius:8, fontSize:11}}/>
          {refMc && <Line type="monotone" dataKey="rpes" name="ref pessimista" stroke="#4b5563" strokeWidth={1} strokeDasharray="2 3" dot={false}/>}
          {refMc && <Line type="monotone" dataKey="roti" name="ref otimista" stroke="#4b5563" strokeWidth={1} strokeDasharray="2 3" dot={false}/>}
          <Line type="monotone" dataKey="oti" name="otimista" stroke="#22c55e" strokeWidth={1.5} strokeDasharray="9 4" dot={false}/>
          <Line type="monotone" dataKey="med" name="mediana" stroke="#6366f1" strokeWidth={2} dot={false}/>
          <Line type="monotone" dataKey="pes" name="pessimista" stroke="#ef4444" strokeWidth={1.5} strokeDasharray="2 3" dot={false}/>
        </LineChart>
      </ResponsiveContainer>
    </div>
  )
}
